<template>
	<div class="file_input_box">
		<md-field :class="{ 'md-error': !!error }">
			<label>{{ $t(placeholderKey) }}</label>
			<md-input :value="fileName" type="text" :required="required"></md-input>
			<span v-if="error" class="validation-error">{{ error }}</span>
			<i class="fa" :class="this.iconName" aria-hidden="true"></i>
		</md-field>
		<div class="common_pdf_upload_box">
			<el-upload
				:show-file-list="false"
				:disabled="isLoading || disable"
				:show-text="false"
				:accept=acceptType
				drag
				:http-request="uploadFile"
				action=""
			></el-upload>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		value: { type: Object },
		uploadFunction: Function,
		placeholderKey: { type: String, default: "common.upload.document" },
		iconName: { type: String, default: "fa-file-pdf-o" },
		acceptType: {type: String, default: ".pdf"},
		disable: Boolean,
		required: { type: Boolean, default: false },
		error: { type: String, default: "" },
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		fileName() {
			return this.value ? this.value.fileName : "";
		}
	},
	methods: {
		uploadFile(params) {
			this.uploadFunction(params)
				.then(function(res) {
					this.changeFileData(res);
					this.toastSuccess(this.$t("common.upload.document.success", { documentName: res.fileName }));
				}.bind(this))
				.catch(err => {
					this.toast(err);
				});
		},
		getUploadedFile() {
			return this.value || { fileId: "", fileName: "" };
		},
		changeFileData(file) {
			this.value = {
				fileId: file.fileId,
				fileName: file.fileName
			};

			this.$emit("input", this.value);
		},
	},
	watch: {
		disable() {
			if (!this.disabled) {
				this.isLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.file_input_box {
	position: relative;
}

.common_pdf_upload_box {
	position: absolute;
	top: 0;
	right: 0;
	opacity: 0;
	width: 100%;
	height: 100%;
}
</style>
